import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/requests';

const namespace = 'DATACAPTURE';

export const FETCH_ROLL_CORRECTIONS = createRequestTypes(
  `${namespace}/FETCH_ROLL_CORRECTIONS`,
);

export const fetchRollCorrections = makeApiActionCreatorV3(
  api.fetchRollCorrections,
  FETCH_ROLL_CORRECTIONS[START],
  FETCH_ROLL_CORRECTIONS[SUCCESS],
  FETCH_ROLL_CORRECTIONS[ERROR],
);

export const CREATE_REQUEST = createRequestTypes(`${namespace}/CREATE_REQUEST`);

export const createRequest = makeApiActionCreatorV3(
  api.createRequest,
  CREATE_REQUEST[START],
  CREATE_REQUEST[SUCCESS],
  CREATE_REQUEST[ERROR],
);

export const GET_REQUEST = createRequestTypes(`${namespace}/CREATE_REQUEST`);

export const getRequest = makeApiActionCreatorV3(
  api.getRequest,
  GET_REQUEST[START],
  GET_REQUEST[SUCCESS],
  GET_REQUEST[ERROR],
);

export const GET_OPEN_RECORDS = createRequestTypes(
  `${namespace}/GET_OPEN_RECORDS`,
);

export const getOpenRecords = makeApiActionCreatorV3(
  api.getOpenRecords,
  GET_OPEN_RECORDS[START],
  GET_OPEN_RECORDS[SUCCESS],
  GET_OPEN_RECORDS[ERROR],
);

export const DOWNLOAD_EXPORT_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_EXPORT_FILE`,
);

export const downloadExportFile = makeApiActionCreatorV3(
  api.downloadExportFile,
  DOWNLOAD_EXPORT_FILE[START],
  DOWNLOAD_EXPORT_FILE[SUCCESS],
  DOWNLOAD_EXPORT_FILE[ERROR],
);

export const SEARCH_MARKET_AREA = createRequestTypes(
  `${namespace}/SEARCH_MARKET_AREA`,
);

export const searchMarketArea = makeApiActionCreatorV3(
  api.searchMarketArea,
  SEARCH_MARKET_AREA[START],
  SEARCH_MARKET_AREA[SUCCESS],
  SEARCH_MARKET_AREA[ERROR],
);
